import { motion } from "framer-motion";
import { CheckCircle2, Phone } from "lucide-react";
import { BENEFITS, IMAGES, CONTACT } from "../data";

export const WhyChooseUs = () => {
  return (
    <section id="why" data-testid="why-choose-us-section" className="py-20 sm:py-28 bg-brand-surface">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative"
        >
          <div className="rounded-2xl overflow-hidden shadow-[0_18px_50px_rgba(74,53,40,0.18)]">
            <img src={IMAGES.craftsman} alt="Craftsman measuring with precision" className="w-full h-[460px] object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-2 sm:right-6 bg-brand-brown text-brand-bg rounded-2xl px-6 py-5 shadow-xl max-w-[210px]">
            <p className="font-display font-extrabold text-3xl leading-none">100%</p>
            <p className="text-xs text-brand-bg/80 mt-1 leading-snug">
              Focused on getting it right the first time.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-brand-olive font-medium tracking-widest uppercase text-sm mb-3">
            Why All Done Handyman
          </p>
          <h2 className="font-display font-extrabold text-brand-brown text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
            A perfectionist&apos;s eye for every detail.
          </h2>
          <p className="mt-4 text-brand-muted text-base sm:text-lg leading-relaxed">
            Skilled, creative and reliable — bringing joinery, plumbing and
            electrical know-how together so you only need to call one person.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-4">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-start gap-3">
                <CheckCircle2 size={20} className="text-brand-olive shrink-0 mt-0.5" />
                <span className="text-brand-ink text-[15px] leading-snug">{b}</span>
              </li>
            ))}
          </ul>

          <a
            href={CONTACT.phoneRaw}
            data-testid="why-call-button"
            className="mt-9 inline-flex items-center gap-2 rounded-full bg-brand-brown px-7 py-4 font-semibold text-brand-bg hover:bg-brand-brownDark hover:scale-105 transition-all"
          >
            <Phone size={18} /> Let&apos;s talk about your project
          </a>
        </motion.div>
      </div>
    </section>
  );
};
